<template>
  <div>
    <Header2 />

    <div class="rg-c">
      <div class="gc-x">
        <h2 class="hc-x">Admin Sign In</h2>
        <main>
          <Message :status="status" :message="message" />

          <form @submit.prevent="handleSubmit">
            <div class="ml-xf">
              <label for="id">Email or Username</label>
              <input
                id="id"
                type="text"
                placeholder="Enter your Email or Username"
                v-model="id"
                required
              />
            </div>

            <div class="ml-xf">
              <label for="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="Enter your password"
                v-model="password"
                required
                autocomplete="current-password"
              />
              <span class="forget">
                <router-link to="/forget/reset">Forget Password?</router-link>
              </span>
            </div>

            <div class="ml-xf">
              <button :disabled="isDisabled">{{ btnText }}</button>
            </div>
          </form>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import Header2 from "../../components/header2.vue";
import Message from "../../components/message.vue";
import axios from "axios";

export default {
  name: "AdminLogin",
  components: { Header2, Message },
  data() {
    return {
      id: "",
      password: "",
      status: null,
      message: "",
      btnText: "Sign In",
      isDisabled: false,
    };
  },
  methods: {
    async handleSubmit() {
      this.btnText = "Loading...";
      this.isDisabled = true;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BASE_URL}api/auth/admin/login`,
          { id: this.id, password: this.password },
        );

        console.log(response);
        localStorage.setItem("id", JSON.stringify(response.data?.id));
        this.$router.push("/verify-login");
      } catch (e) {
        const status = e.response?.status;
        this.status = false;
        this.message =
          status == 400 || status == 422
            ? e.response.data.message
            : "Connection problem, try checking your network";
        this.btnText = "Sign In";
        this.isDisabled = false;
        setTimeout(() => {
          this.status = null;
        }, 3000);
      }
    },
  },
};
</script>

<style scoped>
.rg-c {
  font-family: "Quicksand", Georgia, "Times New Roman", Times, serif;
  font-size: 1.6rem;
  padding: 10px;
}
.rg-c .gc-x {
  max-width: 400px;
  width: 100%;
  margin: 100px auto;
  background: #fff;
  box-shadow: 0px 1px 15px 1px rgb(62 57 107 / 7%);
  padding: 10px;
  border-radius: 15px;
}
.hc-x {
  font-size: 1.2rem;
  padding: 10px;
  margin: 0;
  color: #222;
  font-weight: 700;
}
main {
  margin-top: 20px;
}
label {
  font-size: 1rem;
  color: #000;
}
input {
  outline: none;
  box-sizing: border-box;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #ccc;
  width: 96%;
  padding: 10px;
}
input::-webkit-input-placeholder {
  font-family: "Quicksand", Georgia, "Times New Roman", Times, serif;
}
button {
  padding: 10px;
  color: #fff;
  font-size: 1rem;
  background: #0a1aa8;
  border: 1px solid #0a1aa8;
  border-radius: 10px;
  width: 96%;
  margin-top: 10px;
  box-shadow: 0px 1px 15px 1px rgb(62 57 107 / 7%);
}
.ml-xf {
  width: 100%;
  padding: 10px 10px 0;
}
.forget {
  font-size: 0.9rem;
  color: #0a1aa8;
  font-weight: 800;
  float: right;
  margin: 10px;
}
.forget a {
  color: #0a1aa8;
}
@media screen and (max-width: 490px) {
  label {
    font-size: 0.9rem;
    margin: 5px;
  }
  input {
    width: 95%;
    margin: 5px;
  }
  button {
    width: 95%;
    font-size: 0.9rem;
  }
}
</style>
